import React, { useState } from "react";
import { Box, Container, Typography, Alert, Paper, Fade, LinearProgress } from "@mui/material";
import SummarizeIcon from "@mui/icons-material/Summarize";
import Navbar from "../../Navbar";
import FiltrosListado from "./components/FiltrosListado";
import { descargarListadoClientesCsv } from "./services/listadoClientes.service";

function ListadoClientes() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [mensajeOk, setMensajeOk] = useState(null);

  const handleExportar = async ({ sucursal, desde, hasta, tiposCliente, ordenPor, ordenDir }) => {
    setLoading(true);
    setError(null);
    setMensajeOk(null);
    try {
      await descargarListadoClientesCsv({
        sucursalId: sucursal.id,
        desde,
        hasta,
        tiposCliente: tiposCliente?.map((t) => t.id) ?? [],
        ordenPor,
        ordenDir,
      });
      setMensajeOk("El Excel se descargó correctamente.");
    } catch (err) {
      setError(err.message || "No se pudo generar el reporte.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh" }}>
      <Navbar />

      <Container maxWidth="md" sx={{ px: { xs: 2, sm: 3, md: 4 }, py: 4 }}>
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            p: 2.5,
            mb: 2.5,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "primary.main",
            color: "primary.contrastText",
          }}
        >
          <SummarizeIcon sx={{ fontSize: 34 }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              Listado de clientes
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Kilos facturados por cliente, agrupados por mes, para una sucursal y rango de fechas
            </Typography>
          </Box>
        </Paper>

        <FiltrosListado onExportar={handleExportar} loading={loading} />

        {loading && (
          <Box sx={{ mb: 2 }}>
            <LinearProgress />
            <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: "block" }}>
              Generando el Excel, puede tardar unos segundos...
            </Typography>
          </Box>
        )}

        <Fade in={Boolean(error)} unmountOnExit>
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        </Fade>

        <Fade in={Boolean(mensajeOk)} unmountOnExit>
          <Alert severity="success" sx={{ mb: 2 }} onClose={() => setMensajeOk(null)}>
            {mensajeOk}
          </Alert>
        </Fade>
      </Container>
    </Box>
  );
}

export default ListadoClientes;
